import { render, staticRenderFns } from "./EditPassworModal.vue?vue&type=template&id=49fd70fa"
import script from "./EditPassworModal.vue?vue&type=script&lang=js"
export * from "./EditPassworModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports